import { useEffect, useState } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { useMediaPredicate } from 'react-media-hook';

import Loader from 'components/Loader';
import { PATH_ROUTES } from 'routes/path';
import MedsiMonitor from '../MedsiMonitor';
import MedsiQRScan from './MedsiQRScan';
import MedsiScanIntro, { SHOW_MEDSI_SCAN_INTRO_KEY } from './MedsiScanIntro';

export default function MedsiStartScanPage() {
  const { pathname } = useLocation();
  const hasTrailingSlash = pathname.endsWith('/');
  const isSmallScreen = useMediaPredicate('(max-width: 1024px)');
  const [searchParams] = useSearchParams();
  const show_scan = searchParams.get('showScan');

  const [showInstruction, setShowInstruction] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    if (show_scan) {
      setShowInstruction(false);
      setIsLoading(false);
      return;
    }

    const storedValue = localStorage.getItem(SHOW_MEDSI_SCAN_INTRO_KEY);
    if (storedValue !== null) {
      setShowInstruction(storedValue === 'true');
    }
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, [show_scan]);

  if (hasTrailingSlash) {
    return <Navigate to={PATH_ROUTES.START_FACE_SCAN} replace />;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (!isSmallScreen) {
    return <MedsiQRScan />;
  }

  if (showInstruction) {
    return <MedsiScanIntro onFinish={() => setShowInstruction(false)} />;
  }

  return <MedsiMonitor />;
}
